import React, { useEffect, useState } from 'react';
import ExportPDF from '../../../components/ExportPdf';
import { useLocation } from 'react-router-dom';
import Brown from './variations/Brown';
import Violet from './variations/Violet';
import Blue from './variations/Blue';
import Orange from './variations/Orange';
import dayjs from 'dayjs';

const getThemeComponent = (theme) => {
  if (theme === 'brown') return Brown;
  if (theme === 'violet') return Violet;
  if (theme === 'blue') return Blue;
  return Orange;
};

const ExportWeekPDF = () => {
  const location = useLocation();
  const { theme, ...otherProps } = location.state;

  const ThemeComponent = getThemeComponent(theme);

  const [events, setEvents] = useState(null);

  useEffect(() => {
    const monday = otherProps.monday;

    if (!monday) return;

    const start = dayjs(monday).startOf('month').toDate();
    const end = dayjs(monday).endOf('month').toDate();
  }, [otherProps.monday, setEvents]);

  return (
    <ExportPDF redirectUrl="/animations">
      <ThemeComponent {...otherProps} />
    </ExportPDF>
  );
};

export default ExportWeekPDF;
